module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDExIDE3Ij4KICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xLjU0NCAxLjA1TDguOTY2IDguNWwtNy40MjIgNy40NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/img/arrow.svg
// module id = 73iu
// module chunks = 1